import { useState } from 'react';
import { Form, Space, Tooltip } from 'antd';
import { AppFormSection } from '../../../../../../../../../../ui/AppFormSection';
import { useLocalization } from '../../../../../../../../../../lib/hooks/useLocalization';
import { IconButton } from '../../../../../../features/IconButton';
import { CircleXIcon } from '../../../../../../../../../../ui/icons/CircleXIcon';
import { LinkIcon } from '../../../../../../../../../../ui/icons/LinkIcon';
import { handleTranslation } from '../../../../../../../../../../lib/util/helpers';
import { FormItemName } from '../../../../../../../../../../lib/models/Form';
import { FinderFileLoader } from '../../../../../../features/FinderFileLoader';
import { UploadImageLabel } from '../../../../../../features/UploadImageLabel';
import './styles.scss';

const MAX_FILE_SIZE = 0.5;

// eslint-disable-next-line max-lines-per-function
export function ButtonLinkRow({ linkObject, remove, isMaxLength }) {
  const { translations } = useLocalization();
  const { linkLabel, linkUrl } = translations.unique.formItems;
  const { deleteBtn } = translations.shared.generic;
  const { design } = translations.unique.pages.settings;

  const unlimited = 999;
  const maxLength = 15;

  const [uploadingIcon, setUploadingIcon] = useState(false);
  const formInstance = Form.useFormInstance();

  const buttonLinks = Form.useWatch(FormItemName.BUTTON_LINKS, formInstance) || [];
  const currentLink = buttonLinks[linkObject.name] || {};
  const currentIcon = currentLink[FormItemName.LINK_ICON];

  const updateIconInForm = file => {
    const links = formInstance.getFieldValue(FormItemName.BUTTON_LINKS) || [];
    const updatedLinks = [...links];
    const current = updatedLinks[linkObject.name] || {};

    updatedLinks[linkObject.name] = {
      ...current,
      [FormItemName.LINK_ICON]: file,
    };

    formInstance.setFieldValue(FormItemName.BUTTON_LINKS, updatedLinks);
  };

  const removeIconFromForm = () => {
    const links = formInstance.getFieldValue(FormItemName.BUTTON_LINKS) || [];
    const updatedLinks = [...links];

    if (!updatedLinks[linkObject.name]) return;

    const { [FormItemName.LINK_ICON]: _removed, ...rest } = updatedLinks[linkObject.name];
    updatedLinks[linkObject.name] = rest;

    formInstance.setFieldValue(FormItemName.BUTTON_LINKS, updatedLinks);
  };

  return (
    <>
      <Space size='middle' style={{ alignItems: 'flex-start' }}>
        <AppFormSection
          formItemProps={{
            name: [linkObject.name, FormItemName.LINK_NAME],
            style: { width: 387 },
            rules: [
              {
                required: true,
                message: handleTranslation(linkLabel.errors.required),
              },
              {
                max: isMaxLength ? maxLength : unlimited,
                message: 'Maximum length of the input must be 15',
              },
            ],
          }}
          textFieldProps={{ label: linkLabel.label }}
        />
        <AppFormSection
          className='button_link_url'
          formItemProps={{
            name: [linkObject.name, FormItemName.LINK_URL],
            style: { width: 387 },
            rules: [
              {
                required: true,
                message: handleTranslation(linkUrl.errors.required),
              },
              {
                type: 'url',
                message: handleTranslation(linkUrl.errors.invalid),
              },
            ],
          }}
          textFieldProps={{ label: linkUrl.label, prefix: <LinkIcon /> }}
        />

        <Tooltip placement='top' title={deleteBtn()}>
          <div className='button_link_delete_btn'>
            <IconButton onClick={() => remove(linkObject.name)} icon={<CircleXIcon className='button_link_delete_icon' />} />
          </div>
        </Tooltip>
      </Space>
      <FinderFileLoader
        afterUploadAction={file => updateIconInForm(file)}
        errorText={design.beforeUploadFileError()}
        maxFileSize={MAX_FILE_SIZE}
        disabled={uploadingIcon}
        setUploading={setUploadingIcon}
        uploadLabel={
          <UploadImageLabel
            mediaObject={uploadingIcon ? {} : currentIcon}
            uploading={uploadingIcon}
            deleteOnClick={removeIconFromForm}
            imgHeight={32}
          />
        }
      />
    </>
  );
}
